import { GameUI } from "game/gameUI/GameUI";
import { Popups } from "ui/types/popups";

const website_version = "1.4.1";

export function useFeedBackFormSubmitter(textarea: HTMLTextAreaElement | null, submitButton: HTMLButtonElement | null, screenRes: HTMLInputElement | null) {
    return async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const feedback = textarea?.value.trim();
    
        // Screen Resolution
        screenRes!.value = window.screen.width + "x" + window.screen.height;
        const screen_resolution = window.screen.width + "x" + window.screen.height;
    
        // Device Type
        function getDeviceType() {
        const ua = navigator.userAgent;
    
        if (/tablet|ipad|playbook|silk|(android(?!.*mobi))/i.test(ua)) {
            return "Tablet";
        }
    
        if (/Mobile|iPhone|Android/i.test(ua)) {
            return "Mobile";
        }
    
        return "Desktop";
        }
        const device_type = getDeviceType();
    
        // OS
    
        function getOS() {
        const ua = navigator.userAgent;
    
        if (/Windows NT 10.0/i.test(ua)) return "Windows 10";
        if (/Windows NT 11.0/i.test(ua)) return "Windows 11";
        if (/Windows NT 6.3/i.test(ua)) return "Windows 8.1";
        if (/Windows NT 6.2/i.test(ua)) return "Windows 8";
        if (/Windows NT 6.1/i.test(ua)) return "Windows 7";
        if (/Mac OS X 10[._]\d+/i.test(ua)) return "macOS";
        if (/Android/i.test(ua)) return "Android";
        if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
        if (/Linux/i.test(ua)) return "Linux";
    
        return "Unknown";
        }
    
        const os = getOS();
    
        // Browser
    
        function getBrowser() {
        const ua = navigator.userAgent;
    
        if (ua.includes("Edg/")) return "Microsoft Edge";
        if (ua.includes("OPR/") || ua.includes("Opera")) return "Opera";
        if (ua.includes("Chrome") && !ua.includes("Edg/") && !ua.includes("OPR/"))
            return "Chrome";
        if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
        if (ua.includes("Firefox")) return "Firefox";
        if (ua.includes("MSIE") || ua.includes("Trident/"))
            return "Internet Explorer";
    
        return "Unknown";
        }
    
    function getBrowserVersion() {
        const ua = navigator.userAgent;
        // Edge (Chromium)
        if (ua.includes("Edg/")) {
        return ua.match(/Edg\/([\d\.]+)/)?.[1] || "Unknown";
        }
        // Opera
        if (ua.includes("OPR/") || ua.includes("Opera")) {
        return ua.match(/(?:OPR|Opera)\/([\d\.]+)/)?.[1] || "Unknown";
        }
        // Chrome (and iOS Chrome - CriOS)
        if (ua.includes("Chrome") && !ua.includes("Edg/") && !ua.includes("OPR/")) {
        const chrome = ua.match(/Chrome\/([\d\.]+)/)?.[1];
        const crios = ua.match(/CriOS\/([\d\.]+)/)?.[1];
        return chrome || crios || "Unknown";
        }
        // Safari (uses Version/x.y)
        if (ua.includes("Safari") && !ua.includes("Chrome")) {
        return ua.match(/Version\/([\d\.]+)/)?.[1] || ua.match(/Safari\/([\d\.]+)/)?.[1] || "Unknown";
        }
        // Firefox
        if (ua.includes("Firefox")) {
        return ua.match(/Firefox\/([\d\.]+)/)?.[1] || "Unknown";
        }
        // Internet Explorer
        if (ua.includes("MSIE")) {
        return ua.match(/MSIE\s([\d\.]+)/)?.[1] || "Unknown";
        }
        if (ua.includes("Trident/")) {
        return ua.match(/rv:([\d\.]+)/)?.[1] || "11";
        }
        return "Unknown";
    }
    
        const browser = getBrowser();
    const browser_version = getBrowserVersion();
    
        // LocalData
    
        const localData = {
        back: localStorage.getItem("back"),
        background: localStorage.getItem("background"),
        front: localStorage.getItem("front"),
        leftHanded: localStorage.getItem("leftHanded"),
        soundOn: localStorage.getItem("soundOn"),
        autoPlay: localStorage.getItem("autoPlay"),
        cardHighlighting: localStorage.getItem("cardHighlighting"),
        autocomplete: localStorage.getItem("autocomplete"),
        wins: localStorage.getItem("wins"),
        gameWins: localStorage.getItem("gameWins"),
        };
    
    
        // AdBlocker
    
        async function hasAdBlocker() {
        try {
            const response = await fetch(
            "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6385473659549367",
            {
                method: "HEAD",
                cache: "no-store",
            }
            );
            return false;
        } catch (e) {
            return true;
        }
        }
    
        const adBlockEnabled = await hasAdBlocker();
    
        // All values to send
    
        const data = {
        feedback,
        screen_resolution,
        device_type,
        os,
        browser,
        browser_version,
        adBlock: adBlockEnabled ? "true" : "false",
        ...localData,
        website_version,
        };
    
        if (!feedback) {
        alert("Please enter your feedback before submitting.");
        return;
        }
        let requestOpen = true;
    
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.classList.add("pending");
        }
        
        if (textarea) {
            textarea.disabled = true;
        }
    
        const url = "/feedback.php";
    
        const request = new XMLHttpRequest();
        request.open("POST", url, true);
        request.setRequestHeader("Content-Type", "application/json");
        request.timeout = 5 * 1000;
        request.withCredentials = true;
        request.setRequestHeader("Accept", "application/json");
        try {
        request.send(JSON.stringify(data));
        } catch (error) {
        console.log("no internet");
        new CustomEvent("feedbackError", {
            detail: { message: "custom timeout" },
        });
        }
        let sendingTimeout = setTimeout(() => {
        if (requestOpen) {
            requestOpen = false;
            request.abort();
            if (submitButton) {
                submitButton.classList.remove("pending");
                submitButton.disabled = false;
            }
            if (textarea) {
                textarea.disabled = false;
                textarea.value = ""; // Clear the textarea
            }
            GameUI.closePopup(Popups.FEEDBACK_POPUP, true);

            dispatchEvent(
            new CustomEvent("feedbackError", {
                detail: { message: "custom timeout" },
            })
            );
        }
        }, 5.1 * 1000);
    
        request.onreadystatechange = function () {
        console.log("request.readyState", request.readyState);
        clearTimeout(sendingTimeout);
        requestOpen = false;
        if (submitButton) {
            submitButton.classList.remove("pending");
            submitButton.disabled = false;
        }
        if (textarea) {
            textarea.disabled = false;
        }
    
        if (request.readyState === 4) {
            console.log("request.status", request.status);
            if (request.status === 0) {
            requestOpen = false;
            request.abort();
            if (submitButton) {
                submitButton.classList.remove("pending");
                submitButton.disabled = false;
            }
            if (textarea) {
                textarea.disabled = false;
                textarea.value = ""; // Clear the textarea
            }
            GameUI.closePopup(Popups.FEEDBACK_POPUP, true);
            dispatchEvent(
                new CustomEvent("feedbackError", {
                detail: { message: "custom timeout" },
                })
            );
            }
            if (request.status === 200) {
            const status = JSON.parse(request.response);
            GameUI.closePopup(Popups.FEEDBACK_POPUP, true);
            if (textarea) {
                textarea.value = ""; // Clear the textarea
            }
    
            if (status.status === "success") {
                dispatchEvent(
                new CustomEvent("feedbackSuccess", {
                    detail: { message: status.responseText },
                })
                );
            } else {
                dispatchEvent(
                new CustomEvent("feedbackError", {
                    detail: { message: status.responseText },
                })
                );
                return;
            }
            }
        }
        };
    };
  }